import axios from 'axios'

export default new class UserService {
  login (email, password) {
    const requestData = { email, password }
    return axios.post('/authenticate', requestData)
  }

  // Users management API per USERS_API.md
  list (params = {}) {
    return axios.get('/users', { params })
  }

  get (id) {
    return axios.get(`/users/${id}`)
  }

  create (data) {
    // expects: { email, password, role? }
    return axios.post('/users', data)
  }

  update (id, data) {
    // data: any subset of { email, password, role }
    return axios.put(`/users/${id}`, data)
  }

  delete (id) {
    return axios.delete(`/users/${id}`)
  }
}()
